var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 10.5L8.35885 7.08003C8.23 6.9499 8.15771 6.77417 8.15771 6.59103C8.15771 6.4079 8.23 6.23217 8.35885 6.10203C8.42212 6.03778 8.49754 5.98676 8.58072 5.95193C8.6639 5.91711 8.75317 5.89917 8.84335 5.89917C8.93352 5.89917 9.0228 5.91711 9.10598 5.95193C9.18915 5.98676 9.26458 6.03778 9.32785 6.10203L13.1578 10.01C13.2865 10.1405 13.3587 10.3163 13.3587 10.4995C13.3587 10.6828 13.2865 10.8586 13.1578 10.989L9.32785 14.897C9.26458 14.9613 9.18915 15.0123 9.10598 15.0471C9.0228 15.082 8.93352 15.0999 8.84335 15.0999C8.75317 15.0999 8.6639 15.082 8.58072 15.0471C8.49754 15.0123 8.42212 14.9613 8.35885 14.897C8.23 14.7669 8.15771 14.5912 8.15771 14.408C8.15771 14.2249 8.23 14.0492 8.35885 13.919L11.4998 10.5Z",
    fill: "#534DE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSlide);
export default __webpack_public_path__ + "static/media/right-slide.fbc662ecd0c6eba160a70988bbe38f69.svg";
export { ForwardRef as ReactComponent };